module.exports = __webpack_public_path__ + "static/symbols@2x.25a73919.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/symbols@2x.png
// module id = 452
// module chunks = 35783957827783